/**
 * What to print where a £0 slot would otherwise show a price.
 *
 * Admin can word a £0 slot differently per product (the Story of Us keepsake card says
 * "Included"), so `feeDescription` wins when it holds real text. Mirrors the empty/null/'null'
 * guard the alphanumeric slot already applies to the same metaobject field.
 *
 * Callers that have no house word of their own pass their existing text as the fallback, so a
 * slot without a `feeDescription` renders exactly as it did before.
 *
 * @param {Object} options - Options object.
 * @param {{ feeDescription?: string|null }|null} [options.slot] - The personalisation slot, or a
 *   summary item carrying the same field.
 * @param {string} [options.fallback='Free'] - What to print when there is no fee description.
 * @returns {string} The label for a zero price.
 */
export function getZeroPriceLabel({ slot, fallback = 'Free' } = {}) {
  const fee = slot?.feeDescription;
  if (typeof fee === 'string' && fee !== '' && fee !== 'null') return fee;
  return fallback;
}
